module.exports = __webpack_public_path__ + "media/components/assets/soccer_image_02-3ee4b5e6d6ba365f561f3961686b7dcd.jpg";